<template>
  <div class="card-content" v-if="internalEbook">
    <div class="media">
      <div class="media-left">
        <figure class="image is-64x64" @click="openAmazonLink">
          <img :src="getEbookCover" :alt="internalEbook.title">
        </figure>
      </div>
      <div class="media-content">
        <p class="title is-4">{{ internalEbook.title }}</p>
        <p class="subtitle is-6">{{ internalEbook.author }}</p>
        <p class="subtitle is-7 has-text-weight-semibold" v-if="internalEbook.ebookType === 'discover'">Bookman Discover 👀 - Read up to 33% of this ebook</p>
        <p class="subtitle is-7 has-text-weight-semibold" v-if="internalEbook.ebookType === 'free'">Free Ebook! Fully read this ebook!</p>
        <p class="subtitle is-7" v-if="internalEbook.isRead && !internalEbook.isCompleted">You're currently reading this ebook.</p>
        <p class="subtitle is-7" v-if="internalEbook.isRead && internalEbook.isCompleted">You've finished this ebook.</p>
      </div>
    </div>
  </div>
</template>

<script>
import ebooksService from '@/services/ebooks.service'

export default {
  name: 'singleEbookCardContent',
  data () {
    return {
      internalEbook: {}
    }
  },
  watch: {
    getEbook (value) {
      this.internalEbook = value
    }
  },
  mounted () {
    this.internalEbook = this.getEbook
  },
  methods: {
    openAmazonLink () {
      this.$store.dispatch('updateEbookOnAmazonLinkClick')
    }
  },
  computed: {
    getEbook () {
      return this.$store.getters.getEbook
    },
    getEbookCover () {
      return ebooksService.getEbookCover(this.internalEbook.title, this.internalEbook.coverUrl)
    }
  }
}
</script>

<style>

</style>
